export default {
  id: 'en',
  languages: {
    en: 'English',
    es: 'Español'
  },
  general: {
    name: 'Biker Mobile',
    businesName: 'Biker Mobile',
    channel: "BikerMobileWeb",
  },
  common: {
    companyTagLine: "Stay Connected. Ride Together.",
    companySubtitle: "Mobile services, trusted biker spots, and eSIMs that support your community.",
    loading: "Loading",
    change: 'Change',
    choose: 'Choose',
    send: "Send",
    sending: "Sending...",
    continue: 'Continue',
    processing: 'Processing...',
    apply: "Apply",
    submit: "Submit",
    submitting: "Submitting...",
    cancel: "Cancel",
    cancelled: "Cancelled",
    back: "Back",
    next: "Next",
    reset: "Reset",
    clear: "Clear",
    delete: "Delete",
    remove: "Remove",
    help: 'Need help?',
    save: "Submit",
    confirm: "Confirm",
    infinity: "∞",
    companyTM: "Biker Mobile © 2025 — All rights reserved"
  },
  footer: {
    coverage: "Coverage",
    faqs: "FAQs",
    contact: "Contact"
  },
  header: {
    fundingSupport: "Biker Mobile supports the funding of:"
  },
  errors: {
    unknown: "Unknown Error",
    timeoutReached: "The server encountered a temporary error and could not complete your request. Please try again later",
    SMSCountExceeded: "Maximum number of requests exceeded\n Please contact customer services",
    userLocked: "User Locked\nPlease contact customer services",
    notAllowed: "You are not allowed to access this page",
    failedPurchase: "Purchase Failed",
    invalidEmailAddress: "This email address does not belong to a registered user",
    alreadyRegistered: "This email or phone number is already registered",
    networkUnavailable: "You're offline. Please make sure you're online and try again",
    customerLoginAsAgent: "You must be an agent to login",
    pendingOrders: "Customer has pending orders",
    emailNotExist: "This email doesn't exist",
    serviceDisconnected: "Service Disconnected. Please contact call centre",
    customerNotFound: "Customer does not exist",
    statusInvalid: "Status invalid",
    paymentFailed: "Payment Failed",
    mustUpdate: "Please update your app to the latest version in the App Store",
    orderFailed: "Order Failed",
    invalidSimLength: "The ICCID is an invalid length",
    simInUse: "The ICCID is already in use",
    productNotLoaded: "Product Not Loaded",
    payments: {
      paymentError01: "Call your bank (01)",
      paymentError02: "Call your bank (02)",
      paymentError06: "Invalid card (06)",
      paymentError07: "Invalid card (07)",
      paymentError13: "Invalid amount(13)",
      paymentError14: "Invalid card (14)",
      paymentError41: "Card reported as lost. Call your bank (41)",
      paymentError57: "Transaction is not allowed (57)",
      paymentError62: "Invalid card (62)",
      paymentError78: "Reserved code (78)",
      paymentError84: "Reserved code (84)",
      paymentError100: "Denied (100)",
      paymentError101: "Card is expired (101)",
      paymentError107: "Call your bank (107)",
      paymentError200: "Invalid card. Call your bank (200)",
      paymentErrorD99: "Invalid format (D99)",
      paymentError15: "We do not recognize the issuing bank (15)",
      paymentError45: "Reserved code (45)",
      paymentError46: "Reserved code (46)",
      paymentError48: "Reserved code (48)",
      paymentError80: "Denied (80)",
      paymentError82: "Invalid card (82)",
      paymentError83: "Invalid card (83)",
      paymentError87: "Invalid card (87)",
      paymentError94: "Duplicate transaction (94)",
      paymentErrorN0: "Try again (N0)",
      paymentErrorR1: "Denied (R1)",
      paymentErrorT5: "Inactive card (T5)",
      paymentError03: "Invalid transaction (03)",
      paymentError05: "Invalid transaction (05)",
      paymentError12: "Transaction not allowed (12)",
      paymentError30: "Format error (30)",
      paymentError51: "Insufficient funds (51)",
      paymentError52: "Account is incorrect (52)",
      paymentError61: "Limit exceeded (61)",
      paymentError65: "Limit exceeded (65)",
      paymentErrorN8: "Denied (N8)",
      paymentErrorO8: "Invalid card (O8)",
      paymentErrorP1: "Transaction not allowed (P1)",
      paymentErrorT4: "Denied (T4)",
      paymentError04: "Denied (04)",
      paymentError34: "Transaction denied. Contact your bank (34)",
      paymentError35: "Transaction denied. Contact your bank (35)",
      paymentError36: "Card denied. Contact your bank (36)",
      paymentError37: "Transaction denied. Contact your bank (37)",
      paymentError43: "Transaction denied. Contact your bank (43)",
      paymentError56: "Card used is not valid. Contact your bank (56)",
      paymentErrorQ5: "Transaction denied. Contact your bank (Q5)",
      paymentErrorN7: "Recurring charge denied. Contact your bank (N7)",
      paymentErrorN6: "Recurring charge denied. Contact your bank (N6)",
    },
    promoCodeErrors: {
      PROMO_NOT_AVAILABLE: "Invalid promo code",
      PROMO_NOT_ACTIVE: "Promo code not available or not active",
      PROMO_EXPIRED: "Promo code is expired",
      PROMO_MAX_REDEMPTIONS_REACHED: "Promo code has reached the maximum number of redemptions",
      COUPON_NOT_FOUND: "No coupon found for the provided promo code",
      COUPON_NOT_ACTIVE: "Related coupon is not active",
      COUPON_EXPIRED: "Related coupon is expired",
      COUPON_NOT_VALID: "Related coupon is not valid",
      COUPON_MAX_REDEMPTIONS_REACHED: "Related coupon has reached the maximum number of redemptions",
      COUPON_PRODUCT_RESTRICTION: "Promo code or coupon not valid for selected product",
      PROMO_CUSTOMER_RESTRICTION: "Promo code or coupon not valid for selected customer",
      PROMO_MINIMUM_AMOUNT_CURRENCY_MISMATCH: "Promo code or coupon not valid for selected currency",
      PROMO_MINIMUM_AMOUNT_NOT_MET: "Promo code minimum amount is not met",
      EMAIL_ADDRESS_REQUIRED: "Missing email address",
      TARGET_PRODUCT_NOT_FOUND: "TARGET_PRODUCT_NOT_FOUND",
      PROMO_COUPON_MISSING: "PROMO_COUPON_MISSING"
    }
  },
  errorMapping: {
    SR0001: {
      authcode: "forms.verificationCodeInvalid",
      registration: "forms.verificationCodeInvalid",
      login: "forms.usernameOrPasswordInvalid",
      forgottenPassword: "forms.verificationCodeInvalid",
      invalidEmailAddress: "errors.emailNotExist"
    },
    SR0002: {
      login: "errors.userLocked",
      forgottenPassword: "errors.userLocked"
    },
    SR0004: {
      login: "errors.userLocked",
    },
    SR0005: {
      login: "errors.notAllowed",
    },
    SR0009: {
      forgottenPassword: "Unauthorized"
    },
    SR0014: {
      registration: "forms.phoneNumberInvalid",
      login: "errors.unknown",
      checkout: "errors.failedPurchase",
      forgottenPassword: "errors.unknown",
      profileAddress: "errors.unknown"
    },
    SR0017: {
      registration: "errors.alreadyRegistered"
    },
    SR0020: {
      forgottenPassword: "errors.invalidEmailAddress"
    },
    SR0022: {
      forgottenPassword: "forms.phoneNumberInvalid",
      registration: "forms.phoneNumberInvalid",
    },
    SR0041: {
      registration: "errors.statusInvalid"
    },
    SR0042: {
      forgottenPassword: "errors.SMSCountExceeded",
      registration: "errors.SMSCountExceeded"
    },
    SR0043: {
      login: "errors.mustUpdate",
      registration: "errors.mustUpdate",
      forgottenPassword: "errors.mustUpdate"
    },
    SR0101: {
      lost: "errors.pendingOrders",
      gift: "errors.pendingOrders",
      checkout: "errors.pendingOrders"
    },
    SR9999: {
      login: "errors.timeoutReached",
      registration: "errors.timeoutReached"
    },
    SR00172: {
      login: "errors.customerNotFound"
    },
    1000: "errors.orderFailed",
    1002: "errors.alreadyRegistered",
    1003: "errors.invalidSimLength",
    1004: "errors.simInUse",
    CREDENTIALS_INVALID: {
      authcode: "forms.verificationCodeInvalid",
      registration: "forms.verificationCodeInvalid",
      login: "forms.usernameOrPasswordInvalid",
      forgottenPassword: "forms.verificationCodeInvalid",
      invalidEmailAddress: "errors.emailNotExist"
    },
    AUTHENTICATION_ERROR: {
      authcode: "forms.verificationCodeInvalid",
      registration: "forms.verificationCodeInvalid",
      login: "forms.usernameOrPasswordInvalid",
      forgottenPassword: "forms.verificationCodeInvalid",
      invalidEmailAddress: "errors.emailNotExist"
    },
    USER_LOCKED: {
      login: "errors.userLocked",
      forgottenPassword: "errors.userLocked"
    },
    MAX_PASSWORD_ATTEMPTS: {
      login: "errors.userLocked",
      forgottenPassword: "errors.userLocked"
    },
    SECURITY_CHECK_INVALID: {
      forgottenPassword: "errors.unauthorised"
    },
    NOT_FOUND: {
      forgottenPassword: "errors.unauthorised"
    },
    UNSPECIFIED_ERROR: {
      registration: "forms.phoneNumberInvalid",
      login: "errors.unknown",
      checkout: "errors.failedPurchase",
      forgottenPassword: "errors.unknown",
      profileAddress: "errors.unknown"
    },
    USER_INVALID: {
      registration: "forms.phoneNumberInvalid",
      login: "errors.unknown",
      checkout: "errors.failedPurchase",
      forgottenPassword: "errors.unknown",
      profileAddress: "errors.unknown"
    },
    NO_USER_EXISTS: {
      login: "errors.customerNotFound"
    },
    CUSTOMER_INVALID: {
      registration: "forms.phoneNumberInvalid",
      login: "errors.unknown",
      checkout: "errors.failedPurchase",
      forgottenPassword: "errors.unknown",
      profileAddress: "errors.unknown"
    },
    FILTER_INVALID: {
      registration: "forms.phoneNumberInvalid",
      login: "errors.unknown",
      checkout: "errors.failedPurchase",
      forgottenPassword: "errors.unknown",
      profileAddress: "errors.unknown"
    },
    CONFIRMED_BASKET_INVALID: {
      checkout: "errors.failedPurchase"
    },
    ALREADY_REGISTERED: {
      registration: "errors.alreadyRegistered"
    },
    USERNAME_UNAVAILABLE: {
      registration: "errors.alreadyRegistered"
    },
    USER_INVALID: {
      forgottenPassword: "errors.invalidEmailAddress"
    },
    SERVICE_INVALID: {
      forgottenPassword: "forms.phoneNumberInvalid",
      registration: "forms.phoneNumberInvalid",
      login: "errors.customerNotFound",
    },
    IS_POOLED: {
      registration: "errors.statusInvalid"
    },
    IS_BLACKLISTED: {
      registration: "errors.statusInvalid"
    },
    REGISTRATION_INVALID: {
      registration: "errors.statusInvalid"
    },
    MAX_NUMBER_OF_AUTHSMS_SENDS: {
      forgottenPassword: "errors.SMSCountExceeded",
      registration: "errors.SMSCountExceeded"
    },
    API_CLIENT_VERSION_NOT_SUPPORTED: {
      login: "errors.mustUpdate",
      registration: "errors.mustUpdate",
      forgottenPassword: "errors.mustUpdate"
    },
    ORDERS_PENDING: {
      lost: "errors.pendingOrders",
      gift: "errors.pendingOrders",
      checkout: "errors.pendingOrders"
    },
    CONNECTION_TIMEOUT: {
      login: "errors.timeoutReached",
      registration: "errors.timeoutReached"
    },
    TIMEOUT: {
      login: "errors.timeoutReached",
      registration: "errors.timeoutReached"
    }
  },
  homepage: {
    hero: {
      getEsim: "Get a Biker eSIM",
      explorePlaces: "Explore Biker-Friendly Places"
    },
    about: {
      title: "Powering Riders With More Than Just Signal",
      text1: "Biker Mobile connects the motorbike community with mobile services on the Vodafone UK network, and helps fund biker causes.",
      text2: "Discover and share biker-friendly cafés, shops, and more — all while giving back with every SIM you buy."
    },
    map: {
      title: "Find Trusted Biker-Friendly Places",
      text: "Explore rider-recommended cafés, mechanics, shops, and more across the UK.",
      explore: "Explore the Map"
    },
    esim: {
      title: "SIMs Built for the Road",
      text1: "UK eSIMs available now. Travel eSIMs and plastic SIMs coming soon.",
      text2: "Every purchase helps support biker charities, events, and accident relief.",
      buy: "Buy Your eSIM"
    },
    intl: {
      title: "Visiting the UK? Stay Connected From the Start.",
      text: "Pre-order your eSIM or SIM and be ready to ride the moment you arrive. Coverage from Vodafone UK."
    },
    community: {
      title: "Connect With Riders Like You",
      text: "Submit new spots, join forums, and discover biker meetups and routes.",
      join: "Join the Community"
    },
    affiliate: {
      title: "Run a Biker Website? Partner With Us.",
      text: "Earn commission for every customer you refer. Easy to join, easy to track.",
      become: "Become an Affiliate"
    }
  },
  plans: {
    h2: "Select Your Plan",
    submit: "Buy now",
    footer: {
      inclusionItem1: "All plans have unlimited UK calls & texts",
      inclusionItem2: "Plans renew automatically (but you can cancel via our app anytime)",
      inclusionItem3: "You can bring your existing mobile phone number to Biker Mobile via our app, after activating",
      inclusionItem4: "Both eSIM and plastic SIMs are supported"
    }
  },
  validateEmail: {
    h2: "Validate Your Email",
    addressPlaceholder: "Enter your email",
    verifyButton: "Verify email address",
    resendOtpButton: "Resend OTP",
    otpSentMessage: "Please check your emails for your one-time passcode (OTP), this could take up to 2 minutes to arrive in your inbox, so please allow for this time before attempting to resend.",
    otpPlaceholder: "Enter OTP",
    confirmButton: "Confirm email (via OTP)",
    temporaryEmailDomains: "Disposable email addresses are not permitted. Please use a different email address."
  },
  basketSnippet: {
    h2: "Your Order",
    total: "Total",
    discountAppliedBasketSnippet: "*The discount will be applied to the price shown above on the next screen when you checkout"
  },
  horizontalTimeline: {
    step1: "Select Plan",
    step2: "Validate Email",
    step3: "Your Details",
    step4: "Payment Details",
    step5: "Download app"
  },
  customerDetails: {
    h2: "Create Your Account",
    emailPlaceholder: "Email",
    firstNamePlaceholder: "First Name",
    lastNamePlaceholder: "Last Name",
    discountCodePlaceholder: "Discount/Promotion Code",
    discountCodeAppliedMessage: (discountName) => `Your code has been accepted. The discount (${discountName || ''}) will be applied on the next screen when you checkout`,
    sim: {
      h3: "SIM Type",
      popUpMessage: "A plastic SIM is a removable chip you insert into your device. An eSIM is embedded in your device and can't be removed but can be reprogrammed to switch carriers or plans through the scanning of a QR code or 'Click to install eSIM'",
      pSIM: "Plastic SIM",
      eSIM: "eSIM",
      verificationMessage: "I have verified that my phone is eSIM compatible"
    }
  },
  postGrid: {
    searchPlaceholder: "e.g. B92 0EJ, Coventry Road",
    moreLocationsMessage: "More locations — keep typing to narrow",
    noResults: "No results",
    tipMessage: "Tip: city/postcode, street + number (e.g., “B92 0EJ, Coventry Road”) for best matches.",
    searchingMessage: "Searching…",
    several: "several",
    addresses: "addresses",
    refineTitle: "Keep typing to refine this area"
  },
  orderCreation: {
    h2: "Order creation",
    processingMessage: "An order is being created for your selected plan: ",
  },
  orderProcessing: {
    h2: "Your order is processing",
    basketRef: "Your basket reference is:",
    processingMessage: "This may take a few minutes. Please do not close this page or refresh your browser.",
    paymentConfirmed: "Confirmed"
  },
  error: {
    genericErrorCode: "Error",
    genericErrorMessage: "Sorry, there has been a problem processing your order.",
    noPaymentTaken: "If a payment was taken then a refund has been issued.",
    pleaseTryAgain: "Please try again.",
    raiseSupportRequest: "If the issue persists, please raise a Support request or contact us through Webchat",
    backToShop: "Back to Biker Mobile shop",
    needHelp: "Need help?",
    contactSupport: "Contact Support"
  },
  confirm: {
    h2: "Welcome to Biker Mobile!",
    orderRef: "Your order reference is:",
    onlineSelfCareName: "On-line Self-care",
    eSimActivateViaSelfCare: "You can now activate your eSIM and manage your account by visiting Biker Mobile",
    eSimDownloadPrompt: "You can also activate by downloading the Biker Mobile App:",
    pSimDispatch: "Your new Biker Mobile SIM will be dispatched and with you in approximately 5 days.",
    pSimActivateViaSelfCare: "When you receive your SIM you can set up your self-care account and activate your SIM by visiting Biker Mobile",
    pSimDownloadPrompt: "You can also manage your account and activate your SIM by downloading the Biker Mobile App:",
    checkMailboxPrompt: "Please check your mailbox for our 'Welcome' email, which includes installation instructions.",
    gettingStartedMessage1: "For additional support, please see our",
    gettingStartedMessage2: "Getting Started",
    gettingStartedMessage3: "web page and our",
    gettingStartedMessage4: "FAQs",
    thankyou: "Thank you for choosing Biker Mobile!"
  }
}
